import {View} from 'react-native'
import {AtUri} from '@atproto/api'
import {Trans} from '@lingui/react/macro'

import {BRAND} from '#/lib/brand'
import {usePalette} from '#/lib/hooks/usePalette'
import {InfoCircleIcon} from '#/lib/icons'
import {makeCustomFeedLink, makeListLink} from '#/lib/routes/links'
import {TextLink} from '../util/Link'
import {Text} from '../util/text/Text'

/**
 * The feed the Following timeline spilled into. Brand-aware: brands with no
 * `feeds` config keep the original hardcoded bsky.app Discover link; ccisd
 * points at its own district-curated list. (This header only renders behind
 * the fallback marker post, which `HomeFeedAPI` only emits when the brand
 * actually HAS a fallback feed.)
 */
const BRAND_FALLBACK = BRAND.feeds?.discoverFeed ?? null
const FALLBACK_LABEL = BRAND_FALLBACK?.label ?? 'Discover'
const FALLBACK_HREF = (() => {
  if (!BRAND_FALLBACK) return '/profile/bsky.app/feed/whats-hot'
  const urip = new AtUri(BRAND_FALLBACK.uri)
  return BRAND_FALLBACK.kind === 'list'
    ? makeListLink(urip.hostname, urip.rkey)
    : makeCustomFeedLink(urip.hostname, urip.rkey)
})()

export function DiscoverFallbackHeader() {
  const pal = usePalette('default')
  return (
    <View
      style={[
        {
          flexDirection: 'row',
          alignItems: 'center',
          paddingVertical: 12,
          paddingHorizontal: 12,
          borderTopWidth: 1,
        },
        pal.border,
        pal.viewLight,
      ]}>
      <View style={{width: 68, paddingLeft: 12}}>
        <InfoCircleIcon size={36} style={pal.textLight} strokeWidth={1.5} />
      </View>
      <View style={{flex: 1}}>
        <Text type="md" style={pal.text}>
          <Trans>
            We ran out of posts from your follows. Here's the latest from{' '}
            <TextLink
              type="md-medium"
              href={FALLBACK_HREF}
              text={FALLBACK_LABEL}
              style={pal.link}
            />
            .
          </Trans>
        </Text>
      </View>
    </View>
  )
}
